import { IconFont } from '@/components/IconFont'
import {
  createOrganizationTerm,
  deleteTerms,
  getOrganizationTermsList,
  updateTerms
} from '@/services/terms/terms.service'
import { useRequest } from 'ahooks'
import { Col, Menu, Row, Space, Typography } from 'antd'
import React, { memo, useContext, useMemo, useState } from 'react'
import { OrganizationContext } from '../..'
import styles from './index.module.less'
import TermsForm from './TermsForm'

export default memo(function OrganizationSettingTerms() {
  const orgData = useContext(OrganizationContext).orgData!
  const [termsList, setTermsList] = useState<any[]>([])
  const [activeKey, setActiveKey] = useState<any>()
  const [isEdit, setIsEdit] = useState(false)
  const activeTerms = useMemo(() => {
    return termsList.find((item) => item.id === activeKey)
  }, [termsList, activeKey])
  const { run: loadTermsList } = useRequest(() => getOrganizationTermsList(orgData.id), {
    onSuccess: (data) => {
      setTermsList(data.sort((a, b) => b.createdTime! - a.createdTime!))
      if (!!data.length) {
        setActiveKey(data[0].id)
      }
    }
  })
  const { run: create } = useRequest(createOrganizationTerm, {
    manual: true,
    onSuccess: () => {
      loadTermsList()
    }
  })
  const { run: update } = useRequest(updateTerms, {
    manual: true,
    onSuccess: () => {
      loadTermsList()
    }
  })

  const { run: remove } = useRequest(deleteTerms, {
    manual: true,
    onSuccess: () => {
      loadTermsList()
    }
  })

  const addTermsHandler = () => {
    if (termsList.some((item) => item.id === -1)) {
      return
    }
    setTermsList([
      {
        id: -1,
        name: 'New Terms',
        content: ''
      },
      ...termsList
    ])
    setActiveKey(-1)
  }

  return (
    <div className={styles.container}>
      <div className={styles.nav}>
        <header className={styles.navHeader}>
          <span>Terms</span>
          <Space>
            <IconFont type={'icon-add'} onClick={addTermsHandler} />
          </Space>
        </header>

        <div className={styles.navContent}>
          <Menu
            selectedKeys={activeKey ? [String(activeKey)] : undefined}
            onSelect={({ key }) => {
              setActiveKey(Number(key))
            }}
          >
            {termsList.map((item) => (
              <Menu.Item key={item.id}>
                <div className={styles.menuItem}>
                  <span className={styles.menuItemName}>{item.name}</span>
                  <span className={styles.menuItemAction}>
                    <IconFont
                      type='icon-shanchu'
                      onClick={() => {
                        remove(item.id)
                      }}
                    />
                  </span>
                </div>
              </Menu.Item>
            ))}
          </Menu>
        </div>
      </div>

      <div className={styles.content}>
        {activeTerms && (
          <>
            {activeTerms.id === -1 ? (
              <TermsForm
                terms={{}}
                onSave={(values) => {
                  create(orgData.id, orgData.termsLibraryId, values)
                }}
                onCancel={() => {
                  setTermsList(termsList.filter((item) => item.id !== -1))
                }}
              />
            ) : (
              <div>
                {isEdit ? (
                  <TermsForm
                    key={activeTerms.id}
                    terms={activeTerms}
                    onSave={(values) => {
                      update(activeTerms.id, values)
                      setIsEdit(false)
                    }}
                    onCancel={() => {
                      setIsEdit(false)
                    }}
                  />
                ) : (
                  <div>
                    <Row justify={'space-between'} wrap={false} gutter={16}>
                      <Col>
                        <Typography.Title level={4}>{activeTerms.name}</Typography.Title>
                      </Col>
                      <Col>
                        <IconFont type='icon-edit' onClick={() => setIsEdit(true)} />
                      </Col>
                    </Row>
                    {/* <OSlateEditor key={activeTerms.id} value={activeTerms.content} readOnly={true} /> */}
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
})
